module.exports = __webpack_public_path__ + "img/sky.161d1800.jpg";